import React from 'react';
import { FormNumber, Fieldset } from '~/components/FormControl';
import { Form, Col } from 'react-bootstrap';

function Damage() {
    return (
        <Col sm={6}>
            <Fieldset>
                <Fieldset.Legend>Damage:</Fieldset.Legend>
                <Form.Row>
                    <FormNumber
                        name={'damageToInflict'}
                        sm={3}
                    />
                    <FormNumber
                        name={'damageToInflictExtra'}
                        sm={3}
                        className={'offset-sm-1'}
                    />
                    <FormNumber
                        name={'damageShield'}
                        sm={3}
                        className={'offset-sm-1'}
                    />
                </Form.Row>
            </Fieldset>
        </Col>
    );
}

export default Damage;
